module.exports = __webpack_public_path__ + "cdaa4acfa13c7e15481a0490cadd6e36.jpg";